import { inject, Injectable } from "@angular/core";
import { AuthenticationService } from "../services/authentication.service";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { PageURL } from "src/app/pages/pages";
import { RefreshmentTimeService } from "src/app/pages/refreshment-time/refreshment-time.service";
import { filter, firstValueFrom, take } from "rxjs";

@Injectable({
  providedIn: 'root'
 })
 export class RestrictedService {
  PageURL: typeof PageURL = PageURL;

  constructor(
    private readonly auth: AuthenticationService,
    private readonly router: Router,
    private readonly refreshmentTimeService: RefreshmentTimeService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const loggedIn = await this.auth.checkStorage();
    const urlPath = '/' + state.root.children[0]?.url.toString();
    const qparam = { returnUrl: urlPath };
    if (!loggedIn) {
      return this.router.createUrlTree([PageURL.WELCOME], { queryParams: qparam });
    }
    const kycStatus = await firstValueFrom(this.refreshmentTimeService.getKycStatusValue().pipe(filter(status => status !== null))) as {KycRefreshment: boolean, POI: string, POA: string};
    //console.log('KYC Status:', kycStatus);
    if (kycStatus.KycRefreshment && state.url !== PageURL.REFRESHMENT && !urlPath.includes('refreshment')) {
      this.router.navigate([PageURL.REFRESHMENT]);
      return false;
    }
    if((kycStatus.POI == 'Approved' || kycStatus.POI == 'Pending Review') && (kycStatus.POA == 'Approved' || kycStatus.POA == 'Pending Review') && (state.url === PageURL.UPLOAD_DOCUMENTS || state.url === PageURL.PROOF_OF_ADDRESS || state.url === PageURL.PROOF_OF_IDENTITY)) {
      this.router.navigate([PageURL.ACCOUNTS]);
      return false;
    }
    return true;
    }
}

export const RestrictedGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): any => {
  return inject(RestrictedService).canActivate(next, state);
};